// extracted by mini-css-extract-plugin
export var buttons = "OrganizationSelect-module--buttons--Kwtcf";
export var container = "OrganizationSelect-module--container--DO83s";
export var form = "OrganizationSelect-module--form--JBFIb";
export var welcomeContent = "OrganizationSelect-module--welcomeContent--PeFPA";